import React from 'react';
import classnames from 'classnames';
import { SPINNER_SIZE, CENTERED } from './config';
import { prefix } from '../../constants';
export const Spinner = ({ loading, centered = CENTERED, size = SPINNER_SIZE, className, children, }) => {
    // Converts the size string to the size expected size in px, with a default of 24px.
    const covertedSize = {
        s: 16,
        m: 24,
        l: 48,
        xl: 96,
    }[size] || 24;
    // stroke width is needed for the calculation of the circle's radius
    const strokeWidth = {
        s: 2,
        m: 3,
        l: 5,
        xl: 10,
    }[size] || 3;
    const radiusSize = covertedSize / 2 - strokeWidth / 2;
    if (loading) {
        return (React.createElement("span", { className: classnames(prefix, 'spinner', className, {
                'spinner-centered': centered,
                'spinner-small': size === 's',
                'spinner-large': size === 'l',
                'spinner-xlarge': size === 'xl',
            }) },
            React.createElement("svg", { focusable: "false", width: covertedSize, height: covertedSize, viewBox: `0 0 ${covertedSize} ${covertedSize}` },
                React.createElement("circle", { cx: covertedSize / 2, cy: covertedSize / 2, r: radiusSize }))));
    }
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=Spinner.js.map